import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { rememberSharedLink } from './app/core/share';
import { environment } from './environments/environment';

rememberSharedLink();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));

/**
 * Never while developing: `ng serve` hands out unhashed bundles, and a worker
 * caching those is a morning lost to a stale app.
 */
if (environment.production && 'serviceWorker' in navigator) {
  addEventListener('load', () => {
    void navigator.serviceWorker.register('sw.js').catch(() => {
      // The app works without it; only installing does not.
    });
  });
}
